import Aboutus from "./AboutUs";
import Dedicated from "./Dedicated";
import Footer from "./Footer";
import Hero from "./Hero";
import Models from "./Models";
import Previews from "./Previews";
import "./global.css";
import ThemeToggle from "@/components/theme-toggle.tsx";
import { LanguageSwitcher } from "@/components/LanguageSwitcher.tsx";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/logo";

export default function Home() {
  const { user } = useAuth();
  const ctaHref = user ? "/dashboard" : "/login";
  const ctaLabel = user ? "Dashboard" : "Login";

  return (
    <main className="home-landing min-h-screen overflow-x-hidden">
      <header className="sticky top-0 z-10 flex items-center h-12 sm:h-14 px-4 border-b bg-background/95 backdrop-blur-sm">
        <Link to="/" className="flex items-center gap-2">
          <Logo className="h-12 w-12" />
          <span className="font-semibold">3D Previewer</span>
        </Link>
        <div className="ml-auto flex items-center gap-3">
          <Link
            to={ctaHref}
            className="text-sm font-medium rounded-full px-3 py-1.5 bg-primary text-white hover:opacity-90 transition"
          >
            {ctaLabel}
          </Link>
          <ThemeToggle />
          <LanguageSwitcher />
        </div>
      </header>
      <Hero />
      <Aboutus />
      <Models />
      <Previews />
      <Dedicated />
      <Footer />
    </main>
  );
}
